import React from 'react';

const KubernetesPlatformSecurity = () => (
  <div className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-extrabold text-gray-800 mb-8" data-aos="fade-up">
          Kubernetes Platform Security
        </h1>
        <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-blue-600" data-aos="fade-up" data-aos-delay="100">
          <p className="text-lg text-gray-700 mb-6">
            <strong>Kubernetes security</strong> involves protecting clusters, workloads, and data from threats and vulnerabilities. Security in Kubernetes is multi-layered, covering identity, network, runtime, and supply chain aspects.
          </p>
          <h2 className="text-2xl font-bold text-blue-700 mb-4 mt-8">How Kubernetes Security Works</h2>
          <p className="mb-4 text-gray-700">
            Key security mechanisms include:
          </p>
          <ul className="list-disc ml-8 mb-6 text-gray-700">
            <li><strong>Role-Based Access Control (RBAC):</strong> Restricts user and service permissions</li>
            <li><strong>Network Policies:</strong> Control traffic between pods and services</li>
            <li><strong>Image Scanning:</strong> Detects vulnerabilities in container images</li>
            <li><strong>Runtime Protection:</strong> Monitors and enforces safe behavior at runtime</li>
            <li><strong>Audit Logging:</strong> Tracks changes and access for compliance</li>
          </ul>
          <h2 className="text-2xl font-bold text-blue-700 mb-4 mt-8">Organizational Benefits</h2>
          <ul className="list-disc ml-8 mb-6 text-gray-700">
            <li>Reduces risk of breaches and data loss</li>
            <li>Ensures regulatory compliance (GDPR, HIPAA, etc.)</li>
            <li>Boosts customer trust and business reputation</li>
            <li>Enables secure innovation and faster delivery</li>
          </ul>
          <p className="text-gray-700">
            Organizations that prioritize Kubernetes security can confidently scale their cloud-native workloads and meet compliance requirements.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default KubernetesPlatformSecurity;
